export enum CasinoGamesConditionalsActionType {
  SET = 'SET_CONDITIONAL',
  RESET = 'RESET_CONDITIONALS'
}

export interface ConditionalsState {
  emptyResults: boolean;
  loading: boolean;
  queryLoading: boolean;
}

export const casinoGamesConditionalsReducer = (
  state: Partial<ConditionalsState>,
  action: {
    type: CasinoGamesConditionalsActionType;
    payload?: Partial<ConditionalsState>;
  }
): Partial<ConditionalsState> => {
  const { type, payload } = action;

  switch (type) {
    case CasinoGamesConditionalsActionType.SET:
      return { ...state, ...payload };
    case CasinoGamesConditionalsActionType.RESET:
      return {};
    default:
      return state;
  }
};
